export const stringValidationRegex = /["'^ˇ<>]/;
export const webpageValidationRegex =
    /^(?:(?:(?:https?|ftp):)?\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
export const emailValidationRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
export const validRegularCharacters = /^[a-zA-Z0-9 ]+$/;
export const projectConnectionNameRegex = /^[a-zA-Z0-9_ \-\/\.\,]+$/;
export const badPayerRegex = /.*BAD-.*/;
